import { PersonDataService } from "../../../core/persons.dataservice";
import { JobTitlesDataService } from "../../../core/jobtitles.dataservice";
import { Ng2StateDeclaration } from "@uirouter/angular";

import { PersonJobTitleEditComponent } from "./person.jobtitle.edit.component";
import { PersonJobTitleComponent } from "./person.jobtitle.component";

import * as dataCore from "../../../core/datacore";

export const personJobTitlesEditState: Ng2StateDeclaration = {
    name: "app.resources.persons.jobtitles.edit",
    url: "/{personJobTitleId:int}",
    views: {
        "main-view@app": {
            component: PersonJobTitleEditComponent
        }
    },
    resolve: {
        isNew: () => false,
        personJobTitle: [PersonDataService.Id, "$stateParams", function (personsService: PersonDataService, $stateParams) {
            return personsService.getPersonJobTitle($stateParams.personJobTitleId);
        }],
        person: [PersonDataService.Id, "$stateParams", function (personsService: PersonDataService, $stateParams) {
            return personsService.get($stateParams.personId);
        }],
        jobTitles: [JobTitlesDataService.Id, function (jobtitleDataService: JobTitlesDataService) {
            return jobtitleDataService.getAll();
        }]
    }
};

export const personJobTitlesNewState: Ng2StateDeclaration = {
    name: "app.resources.persons.jobtitles.new",
    url: "/new",
    views: {
        "main-view@app": {
            component: PersonJobTitleEditComponent
        }
    },
    resolve: {
        isNew: () => true,
        person: [PersonDataService.Id, "$stateParams", function (personsService: PersonDataService, $stateParams) {
            return personsService.get($stateParams.personId);
        }],
        jobTitles: [JobTitlesDataService.Id, function (jobtitleDataService: JobTitlesDataService) {
            return jobtitleDataService.getAll();
        }],
        personJobTitle: ["person", "jobTitles", function (person: Nema.Crew.Model.Person, jobTitles: Nema.Crew.Model.PersonJob[]) {
            return <Nema.Crew.Model.PersonJob>{
                PersonId: person.Id,
                JobTypeId: jobTitles[0].Id,
                FromDate: dataCore.getTodayUTC()
            };
        }]
    }
};

export const personJobTitlesDetailsState: Ng2StateDeclaration = {
    name: "app.resources.persons.jobtitles.detail",
    url: "/{personJobTitleId:int}",
    views: {
        "main-view@app": {
            component: PersonJobTitleComponent
        }
    },
    resolve: {
        personJobTitle: [PersonDataService.Id, "$stateParams", function (personsService: PersonDataService, $stateParams) {
            return personsService.getPersonJobTitle($stateParams.personJobTitleId);
        }],
        jobtitles: [JobTitlesDataService.Id, "$stateParams", function (jobtitleDataService: JobTitlesDataService) {
            return jobtitleDataService.getAll();
        }],
        isNew: function () {
            return false;
        }
    }
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons/jobtitles/person.jobtitles.states.ts